import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logs.component.scss',
})
export class LogsComponent {
  @Output() logData = new EventEmitter<any>();
  logForm!: FormGroup;
  date = new Date();
  constructor(private fb: FormBuilder) {
    this.initialiseForm();
  }

  initialiseForm() {
    this.logForm = this.fb.group({
      creationDateString: [this.date.toISOString(), Validators.required], // Initial value '', and it's required
      name: [sessionStorage.getItem('userName')],
      comment: [''],
      // description: [''],
    });
  }

  saveLogDetails() {
    // Ensure form is valid before emitting (optional but good practice)
    if (this.logForm.valid) {
      this.logData.emit(this.logForm.value);
      // Optional: Reset form after emitting
    } else {
      console.warn('Logs form is invalid. Not emitting data.');
      this.logForm.markAllAsTouched(); // Show errors
    }
  }
}
